export default "__VITE_ASSET__DpeY65LS__"